<template>
  <div class="tag-menu">
    <div class="tag-menu__inner">
      <h5 class="tag-menu__title">
        Edit Tag
      </h5>

      <div class="tag-menu__col">
        <div class="tag-menu__block">
          <label>Type</label>
          <select
            v-model="value.type"
            class="form-control"
            @input="$emit('recordAction')"
            @change="onTypeChange"
          >
            <option value="basic">Basic</option>
            <option value="basicIcon">Basic Icon</option>
            <option value="box">Box</option>
            <option value="rich">Rich</option>
            <option value="reference">Reference</option>
            <option value="reveal">Reveal</option>
            <option value="action">Action</option>
          </select>
        </div>

        <div
          v-if="
            [
              'basic',
              'basicIcon',
              'box',
              'rich',
              'reference',
              'reveal',
              'action'
            ].includes(value.type)
          "
          class="tag-menu__block"
        >
          <label>
            Label
            <localised-field-indicator />
          </label>
          <input
            v-model="value.label[activeLanguage.code]"
            class="form-control"
            type="text"
            placeholder="label"
            @input="$emit('recordAction')"
          />
        </div>

        <div v-if="value.pos" class="tag-menu__block tag-menu__block--inline">
          <label>X</label>
          <input
            type="number"
            v-model.number="value.pos.x"
            class="form-control"
            @input="$emit('recordAction')"
          />
        </div>

        <div v-if="value.pos" class="tag-menu__block tag-menu__block--inline">
          <label>Y</label>
          <input
            type="number"
            v-model.number="value.pos.y"
            class="form-control"
            @input="$emit('recordAction')"
          />
        </div>

        <!-- Tag Scale (Action tags only) -->
        <div v-if="value.type === 'action'" class="tag-menu__block">
          <label>
            Size
            <span style="font-weight: 400; opacity: 0.8; margin-left: 6px;">
              {{ (value.tagScale || 1).toFixed(2) }}x
            </span>
          </label>

          <div class="tag-scale-slider-wrap">
            <input
              type="range"
              class="tag-scale-slider"
              min="0.5"
              max="2"
              step="0.05"
              v-model.number="value.tagScale"
              @input="$emit('recordAction')"
              :style="sliderBackground"
            />
          </div>
        </div>

        <div v-if="['basic'].includes(value.type)" class="tag-menu__col">
          <div class="tag-menu__block">
            <label style="flex-shrink: 0; margin-right: 10px;">Font Size</label>
            <input
              class="form-control"
              type="number"
              step="0.01"
              v-model.number="value.fontSize"
            />
          </div>

          <div v-if="value.padding" class="tag-menu__block">
            <label style="flex-shrink: 0; margin-right: 10px;">Padding</label>
            <div class="group-block__inputs">
              <div class="group-block__input-wrapper">
                <label>Top</label>
                <input
                  class="form-control"
                  type="number"
                  step="0.01"
                  v-model="value.padding[0]"
                />
              </div>
              <div class="group-block__input-wrapper">
                <label>Bottom</label>
                <input
                  class="form-control"
                  type="number"
                  step="0.01"
                  v-model="value.padding[2]"
                />
              </div>
              <div class="group-block__input-wrapper">
                <label>Left</label>
                <input
                  class="form-control"
                  type="number"
                  step="0.01"
                  v-model="value.padding[3]"
                />
              </div>
              <div class="group-block__input-wrapper">
                <label>Right</label>
                <input
                  class="form-control"
                  type="number"
                  step="0.01"
                  v-model="value.padding[1]"
                />
              </div>
            </div>
          </div>

          <div class="tag-menu__block">
            <label style="flex-shrink: 0; margin-right: 10px;">Rotation</label>
            <input
              class="form-control"
              type="number"
              v-model.number="value.rotation"
            />
          </div>
        </div>

        <template v-if="false">
          <div
            v-if="value.pos"
            class="tag-menu__block tag-menu__block--inline tag-menu__block--inactive"
          >
            <label>W</label>
            <input type="text" v-model.number="width" readonly />
          </div>
          <div
            v-if="value.pos"
            class="tag-menu__block tag-menu__block--inline tag-menu__block--inactive"
          >
            <label>H</label>
            <input type="text" v-model.number="height" readonly />
          </div>
        </template>
      </div>

      <div class="tag-menu__col element-grow">
        <div v-if="['box'].indexOf(value.type) !== -1" class="tag-menu__block">
          <label>
            distance
            <localised-field-indicator />
          </label>
          <input
            v-model="value.distance[activeLanguage.code]"
            class="form-control"
            type="text"
            placeholder="distance"
          />
        </div>

        <div v-if="['box'].indexOf(value.type) !== -1" class="tag-menu__block">
          <label>Arrow degrees</label>
          <input
            v-model.number="value.arrowDeg"
            class="form-control"
            type="number"
            placeholder="arrow degrees"
          />
        </div>

        <div
          v-if="
            ['box', 'basicIcon', 'action', 'rich'].indexOf(value.type) !== -1
          "
          class="tag-menu__block"
        >
          <label>
            Icon Name
            <info-box class="ml-1" :in-menu="true" :left-offset="-55">
              Type in icon name (e.g. bed)
              <a href="https://fontawesome.com/v5/search" target="_blank">
                https://fontawesome.com/v5/search
              </a>
            </info-box>
          </label>
          <div class="icon-selector">
            <div class="icon-selector__input icon-selector__input--preview">
              <input
                v-model="value.icon"
                class="form-control"
                type="text"
                placeholder="Icon name"
              />
              <div class="icon-selector__preview">
                <fa v-if="value.icon" :icon="['fas', value.icon]" />
              </div>
            </div>
          </div>
        </div>

        <div
          v-if="['basic', 'action', 'rich'].indexOf(value.type) !== -1"
          class="tag-menu__block"
          :key="value.action.method"
        >
          <label>Assign Action</label>
          <select
            v-model="value.action.method"
            class="form-control"
            @change="methodChanged"
          >
            <option value="">Unassigned</option>
            <option value="TRIGGER_CHANGE_BACKGROUND">Change Background</option>
            <option value="TRIGGER_SHOW_ASSET">Show Asset</option>
            <option value="TRIGGER_NAV_ROUTER">Navigate to page</option>
            <option value="TRIGGER_CUSTOM_NAV_ROUTER">
              Navigate to custom page
            </option>
          </select>

          <input-asset
            v-if="value.action.method === 'TRIGGER_CHANGE_BACKGROUND'"
            class="mt-2"
            v-model="value.action.payload[0]"
          />

          <div
            v-if="value.action.method === 'TRIGGER_SHOW_ASSET'"
            class="mt-2"
            style="width: 100%"
          >
            <label>
              Assets
              <localised-field-indicator />
            </label>
            <input-asset
              :key="'show-asset-' + activeLanguage.code"
              :multiple="true"
              v-model="localizedActionPayload"
            />
          </div>

          <div
            v-if="
              value.action.method === 'TRIGGER_SHOW_ASSET' &&
                value.action.meta &&
                value.action.meta.objectFit
            "
            class="mt-2"
          >
            <label>Asset Fit</label>
            <toggle-button
              :color="{ checked: '#28a745', unchecked: '#28a745' }"
              :sync="false"
              :labels="{ checked: 'cover', unchecked: 'contain' }"
              :width="80"
              :height="20"
              style="font-weight: 400;"
              :value="actionMetaValue"
              @change="onActionMetaChange"
            />
          </div>

          <div
            v-if="value.action.method === 'TRIGGER_SHOW_ASSET'"
            class="mt-2"
            style="width: 100%"
          >
            <label>
              Virtual Tour Url
              <info-box class="ml-1">
                The last asset will open virtual tour url when clicked
              </info-box>
            </label>
            <input
              v-model="value.virtualTourUrl"
              class="form-control"
              type="text"
              placeholder=""
            />
          </div>

          <select
            v-if="value.action.method === 'TRIGGER_NAV_ROUTER'"
            v-model="value.action.payload[0]"
            class="form-control mt-2"
          >
            <option value="">Select a page</option>
            <option v-for="page in pages" :key="page._id" :value="page._id">
              {{ page.heading.en || page.name }}
            </option>
          </select>

          <input
            v-if="value.action.method === 'TRIGGER_CUSTOM_NAV_ROUTER'"
            class="form-control mt-2"
            type="text"
            v-model="value.action.payload[0]"
          />
        </div>

        <div
          v-if="['reference'].indexOf(value.type) !== -1"
          class="tag-menu__block"
        >
          <label>
            Order override
            <info-box class="ml-1" :in-menu="true" :left-offset="-80">
              Set a custom order for a tag from low to high. Numbers can be
              negative.
            </info-box>
          </label>
          <input
            v-model="value.overrideOrder"
            class="form-control"
            type="text"
            placeholder="0"
          />
        </div>

        <div
          v-if="['reference'].indexOf(value.type) !== -1"
          class="tag-menu__block"
        >
          <label>Is Visible</label>
          <toggle-button
            v-model="value.isVisible"
            color="#28a745"
            :sync="true"
            :labels="false"
            :width="40"
            :height="20"
            style="font-weight: 400"
          />
        </div>

        <div
          v-if="['rich', 'reference', 'reveal'].indexOf(value.type) !== -1"
          class="tag-menu__block element-grow"
        >
          <label>
            description
            <localised-field-indicator />
          </label>
          <textarea
            v-model="value.description[activeLanguage.code]"
            class="form-control element-grow"
            rows="3"
            placeholder="description"
          ></textarea>
        </div>

        <div
          v-if="['rich'].indexOf(value.type) !== -1"
          class="tag-menu__block element-grow"
        >
          <label>
            More Information
            <localised-field-indicator />
          </label>
          <textarea
            v-model="value.moreInformation[activeLanguage.code]"
            class="form-control element-grow"
            rows="3"
            placeholder="more information"
          ></textarea>
        </div>

        <div
          v-if="['rich'].indexOf(value.type) !== -1"
          class="tag-menu__block element-grow"
        >
          <label>QR URL</label>
          <input
            v-model="value.qrUrl"
            class="form-control"
            type="text"
            placeholder="https://"
          />
        </div>

        <!-- background colour -->
        <div
          v-if="
            ['basic', 'basicIcon', 'box', 'action', 'rich'].indexOf(
              value.type
            ) !== -1
          "
          class="tag-menu__block"
        >
          <div class="inline-label">
            <label>Background Colour</label>

            <div class="colour-controls">
              <div
                class="btn-colour"
                :style="{ backgroundColor: value.backgroundColour }"
                @click="toggleColourWidget('backgroundColour')"
              ></div>

              <!-- eyedropper button -->
              <button
                type="button"
                class="btn btn-outline-secondary btn-sm colour-eye-button"
                @click="pickColour('backgroundColour')"
              >
                <fa :icon="['fas', 'eye-dropper']" />
              </button>
            </div>
          </div>

          <verte
            v-if="activeColourWidget === 'backgroundColour'"
            class="colour-picker"
            display="widget"
            picker="square"
            model="rgb"
            v-model="value.backgroundColour"
            :showHistory="true"
            :colorHistory.sync="ColourHistory"
          ></verte>
        </div>

        <!-- text colour -->
        <div
          v-if="
            ['basic', 'basicIcon', 'box', 'rich'].indexOf(value.type) !== -1
          "
          class="tag-menu__block"
        >
          <div class="inline-label">
            <label>Text Colour</label>
            <div class="colour-controls">
              <div
                class="btn-colour"
                :style="{ backgroundColor: value.textColour }"
                @click="toggleColourWidget('textColour')"
              ></div>

              <!-- eyedropper button -->
              <button
                type="button"
                class="btn btn-outline-secondary btn-sm colour-eye-button"
                @click="pickColour('textColour')"
              >
                <fa :icon="['fas', 'eye-dropper']" />
              </button>
            </div>
          </div>

          <verte
            v-if="activeColourWidget === 'textColour'"
            class="colour-picker"
            display="widget"
            picker="square"
            model="rgb"
            v-model="value.textColour"
            :showHistory="true"
            :colorHistory.sync="ColourHistory"
          ></verte>
        </div>

        <!-- tail colour -->
        <div
          v-if="['basic', 'rich', 'action'].indexOf(value.type) !== -1"
          class="tag-menu__block"
        >
          <div class="inline-label">
            <label>Tail Colour</label>

            <div class="colour-controls">
              <div
                class="btn-colour"
                :style="{ backgroundColor: tailColourEffective }"
                @click="toggleColourWidget('tailColour')"
              ></div>

              <button
                type="button"
                class="btn btn-outline-secondary btn-sm colour-eye-button"
                @click="pickColour('tailColour')"
              >
                <fa :icon="['fas', 'eye-dropper']" />
              </button>
            </div>
          </div>

          <verte
            v-if="activeColourWidget === 'tailColour'"
            class="colour-picker"
            display="widget"
            picker="square"
            model="rgb"
            v-model="value.tailColour"
          ></verte>
        </div>

        <!-- box shadow  -->
        <div
          v-if="
            ['basic', 'rich', 'action', 'basicIcon', 'box', 'reveal'].includes(
              value.type
            )
          "
          class="tag-menu__block tag-menu__block--inline"
        >
          <label style="flex-shrink: 0; margin-right: 10px;">Box Shadow</label>
          <toggle-button
            v-model="value.boxShadow"
            color="#28a745"
            :sync="true"
            :labels="false"
            :width="40"
            :height="20"
            style="font-weight: 400"
          />
        </div>

        <div
          v-if="
            ['basic', 'reference', 'rich', 'action'].indexOf(value.type) !== -1
          "
          class="tag-menu__block"
        >
          <label>Tail Position</label>
          <select v-model="value.tailPosition" class="form-control">
            <option value="none">No Tail</option>
            <option value="bottom-left">Bottom Left</option>
            <option value="bottom-center">Bottom Center</option>
            <option value="bottom-right">Bottom Right</option>
            <option value="top-left">Top Left</option>
            <option value="top-center">Top Center</option>
            <option value="top-right">Top Right</option>
            <option value="left-center">Left Center</option>
            <option value="right-center">Right Center</option>
          </select>
        </div>

        <div
          v-if="
            ['basic', 'reference', 'rich', 'action'].indexOf(value.type) !==
              -1 && value.tailPosition !== 'none'
          "
          class="tag-menu__block"
        >
          <label>Tail Length</label>
          <input
            v-model="value.tailHeight"
            class="form-control"
            type="text"
            placeholder="4"
          />
        </div>

        <div
          v-if="['rich'].indexOf(value.type) !== -1"
          class="tag-menu__block tag-menu__block--inline"
        >
          <label>Flip</label>
          <toggle-button
            v-model="value.flip"
            color="#28a745"
            :sync="true"
            :labels="false"
            :width="40"
            :height="20"
            style="font-weight: 400"
          />
        </div>

        <div
          v-if="['rich'].indexOf(value.type) !== -1"
          class="tag-menu__block tag-menu__block--inline"
        >
          <label>Overlay Content</label>
          <toggle-button
            v-model="value.overlayContent"
            color="#28a745"
            :sync="true"
            :labels="false"
            :width="40"
            :height="20"
            style="font-weight: 400"
          />
        </div>

        <div
          v-if="['rich'].indexOf(value.type) !== -1 && value.overlayContent"
          class="tag-menu__block"
        >
          <label>Overlay Opacity</label>
          <input
            v-model.number="value.overlayOpacity"
            step=".1"
            min="0"
            max="1"
            class="form-control"
            type="number"
            placeholder=".5"
          />
        </div>
      </div>

      <div
        v-if="['rich', 'reference', 'reveal'].indexOf(value.type) !== -1"
        class="tag-menu__col"
      >
        <div class="tag-menu__block">
          <label>
            Asset
            <localised-field-indicator />
          </label>
          <input-asset
            :key="'tag-asset-' + activeLanguage.code"
            v-model="localizedAssetId"
            defaultCategory="tagImage"
            :returnid="true"
          ></input-asset>
        </div>
      </div>

      <div class="tag-menu__col tag-menu__col--last buttons-row">
        <button class="btn btn-duplicate" @click="$emit('duplicate', value)">
          Duplicate
        </button>

        <button class="btn btn-remove" @click="$emit('remove', value._id)">
          Remove
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { FETCH_PAGES } from "@/store/actions.type";
import InfoBox from "@/components/InfoBox";
import InputAsset from "@/components/InputAsset";
import Verte from "verte";
import "verte/dist/verte.css";

export default {
  components: { InfoBox, InputAsset, Verte },

  props: {
    value: Object,
    colourHistory: {
      type: Array,
      default: () => []
    }
  },

  data() {
    return {
      height: 0,
      width: 0,
      isTagInfoHidden: true,
      activeColourWidget: null,
      ColourHistory: []
    };
  },

  computed: {
    ...mapGetters(["pages", "activeLanguage"]),

    actionMetaValue() {
      this.ensureAction();
      return this.value.action.meta.objectFit === "cover";
    },

    localizedActionPayload: {
      get() {
        this.ensureLocalizedActionPayload();

        const code =
          this.activeLanguage && this.activeLanguage.code
            ? this.activeLanguage.code
            : "en";

        return this.value.action.payload[code];
      },

      set(payload) {
        this.ensureLocalizedActionPayload();

        const code =
          this.activeLanguage && this.activeLanguage.code
            ? this.activeLanguage.code
            : "en";
        const nextPayload = Array.isArray(payload) ? payload : [];

        this.$set(this.value.action.payload, code, nextPayload);
      }
    },

    localizedAssetId: {
      get() {
        this.ensureLocalizedAssetId();

        const code =
          this.activeLanguage && this.activeLanguage.code
            ? this.activeLanguage.code
            : "en";

        return this.value.assetId[code];
      },

      set(assetId) {
        this.ensureLocalizedAssetId();

        const code =
          this.activeLanguage && this.activeLanguage.code
            ? this.activeLanguage.code
            : "en";
        const nextAssetId = assetId || null;

        this.$set(this.value.assetId, code, nextAssetId);

        this.updateAsset(nextAssetId);
      }
    },

    tailColourEffective() {
      return this.value.tailColour || this.value.backgroundColour || "#ffffff";
    },

    sliderBackground() {
      const min = 0.5;
      const max = 2;
      const val = this.value.tagScale || 1;

      const percent = ((val - min) / (max - min)) * 100;

      return {
        background: `linear-gradient(to right, #28a745 ${percent}%, #e5e7eb ${percent}%)`
      };
    }
  },

  watch: {
    value: {
      deep: true,
      immediate: false,
      handler(newValue) {
        this.ensureAction();

        if (!newValue._id) {
          this.isTagInfoHidden = true;
        }

        // init tagScale if missing (keeps UI slider centered by default)
        if (
          typeof newValue.tagScale === "undefined" ||
          newValue.tagScale === null
        ) {
          this.$set(this.value, "tagScale", 1);
        }
      }
    },

    // "value.backgroundColour"(newBg, oldBg) {
    //   const tail = this.value.tailColour;

    //   const isUnset = tail == null || tail === "";
    //   const wasFollowing = tail === oldBg;

    //   if (isUnset || wasFollowing) {
    //     this.$set(this.value, "tailColour", newBg);
    //   }
    // },

    // whenever the picked asset id changes, refresh the embedded asset object
    "value.assetId"(newId) {
      if (newId && !Array.isArray(newId) && typeof newId === "object") {
        this.updateAsset(this.localizedAssetId);
        return;
      }

      this.updateAsset(newId);
    },

    colourHistory: {
      immediate: true,
      handler(v) {
        this.ColourHistory = Array.isArray(v) ? [...v] : [];
      }
    }
  },

  created() {
    this.ensureAction();
    this.$store.dispatch(FETCH_PAGES);
  },

  methods: {
    ensureAction() {
      if (!this.value.action) {
        this.$set(this.value, "action", {
          method: "",
          payload: [],
          meta: {
            objectFit: "cover"
          }
        });
      }

      if (!this.value.action.meta) {
        this.$set(this.value.action, "meta", {
          objectFit: "cover"
        });
      }
    },

    ensureLocalizedActionPayload() {
      this.ensureAction();
      const legacyPayload = Array.isArray(this.value.action.payload)
        ? [...this.value.action.payload]
        : [];

      if (
        !this.value.action.payload ||
        Array.isArray(this.value.action.payload) ||
        typeof this.value.action.payload !== "object"
      ) {
        this.$set(this.value.action, "payload", {});
      }

      if (
        legacyPayload.length &&
        (!Array.isArray(this.value.action.payload.en) ||
          !this.value.action.payload.en.length)
      ) {
        this.$set(this.value.action.payload, "en", legacyPayload);
      }

      const code =
        this.activeLanguage && this.activeLanguage.code
          ? this.activeLanguage.code
          : "en";

      if (!Array.isArray(this.value.action.payload[code])) {
        this.$set(this.value.action.payload, code, []);
      }
    },

    ensureLocalizedAssetId() {
      if (
        !this.value.assetId ||
        Array.isArray(this.value.assetId) ||
        typeof this.value.assetId !== "object"
      ) {
        this.$set(this.value, "assetId", {
          en: this.value.assetId || null
        });
      }

      const code =
        this.activeLanguage && this.activeLanguage.code
          ? this.activeLanguage.code
          : "en";

      if (!Object.prototype.hasOwnProperty.call(this.value.assetId, code)) {
        this.$set(this.value.assetId, code, null);
      }
    },

    methodChanged(e) {
      this.ensureAction();

      if (e.target.value === "TRIGGER_CHANGE_BACKGROUND") {
        this.value.action.payload = [""];
      }

      if (e.target.value === "TRIGGER_SHOW_ASSET") {
        this.value.action.payload = { en: [] };
        this.ensureLocalizedActionPayload();
      }

      if (
        e.target.value === "TRIGGER_NAV_ROUTER" ||
        e.target.value === "TRIGGER_CUSTOM_NAV_ROUTER"
      ) {
        this.value.action.payload = [""];
      }

      if (!e.target.value) {
        this.value.action.payload = [];
      }
    },

    onActionMetaChange({ value }) {
      this.value.action.meta.objectFit = value ? "cover" : "contain";
    },

    onTypeChange(e) {
      const newType = e.target.value;

      const defaultBackgroundColours = {
        basic: "#ffffff",
        basicIcon: "#2e2e2f",
        box: "#000000",
        rich: "#ffffff",
        reveal: "#000000",
        action: "#000000"
      };

      const defaultTextColours = {
        basic: "#000000", // black on white
        basicIcon: "#ffffff", // white on dark
        box: "#ffffff", // white on black
        rich: "#000000", // black on white
        reveal: "#ffffff", // white on black
        action: "#ffffff" // white on black
      };

      if (
        Object.prototype.hasOwnProperty.call(defaultBackgroundColours, newType)
      ) {
        this.value.backgroundColour = defaultBackgroundColours[newType];
      }

      if (Object.prototype.hasOwnProperty.call(defaultTextColours, newType)) {
        this.value.textColour = defaultTextColours[newType];
      }

      if (
        ["basic", "rich", "action", "basicIcon", "box", "reveal"].includes(
          newType
        ) &&
        typeof this.value.boxShadow === "undefined"
      ) {
        this.$set(this.value, "boxShadow", true);
      }
    },

    // eyedropper for background/text colours
    async pickColour(key) {
      if (typeof window === "undefined" || !("EyeDropper" in window)) {
        if (this.$notify) {
          this.$notify({
            message: "Eyedropper not supported in this browser.",
            horizontalAlign: "center",
            verticalAlign: "top",
            type: "warning"
          });
        }
        return;
      }

      try {
        const eyeDropper = new window.EyeDropper();
        const result = await eyeDropper.open();

        this.$set(this.value, key, result.sRGBHex);
        this.activeColourWidget = null;
      } catch (err) {
        if (err && err.name === "AbortError") {
          return;
        }
        console.error("Eyedropper error", err);
        if (this.$notify) {
          this.$notify({
            message: "Error using eyedropper.",
            horizontalAlign: "center",
            verticalAlign: "top",
            type: "danger"
          });
        }
      }
    },

    toggleColourWidget(key) {
      if (key === this.activeColourWidget) {
        this.activeColourWidget = null;
        return;
      }

      // if opening tailColour for the first time, initialise it to white
      if (key === "tailColour") {
        const isUnset =
          this.value.tailColour == null || this.value.tailColour === "";

        if (isUnset) {
          this.$set(this.value, "tailColour", "#ffffff");
        }
      }

      this.activeColourWidget = key;
    },

    async updateAsset(id) {
      // clear asset if no id
      if (!id) {
        this.$set(this.value, "asset", null);
        return;
      }

      try {
        const asset = await this.$store.dispatch("GET_ASSET_BY_ID", id);
        this.$set(this.value, "asset", asset);
      } catch (err) {
        console.error("Failed to update asset", err);
        if (this.$notify) {
          this.$notify({
            message: "Error loading asset preview.",
            horizontalAlign: "center",
            verticalAlign: "top",
            type: "warning"
          });
        }
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.tag-scale-slider-wrap {
  width: 100%;
  padding: 0 10px; /* half the thumb size */
  overflow: visible;
}

/* Base slider reset */
.tag-scale-slider {
  -webkit-appearance: none !important;
  appearance: none !important;
  width: 100%;
  height: 6px;
  margin-top: 8px;
  padding: 0;
  border-radius: 999px;
  outline: none;
  background: transparent;
}

/* Track */
.tag-scale-slider::-webkit-slider-runnable-track {
  height: 6px;
  border-radius: 999px;
  background: transparent;
}

.tag-scale-slider::-moz-range-track {
  height: 6px;
  border-radius: 999px;
  background: transparent;
}

/* Thumb */
.tag-scale-slider::-webkit-slider-thumb {
  -webkit-appearance: none !important;
  appearance: none !important;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background: #28a745;
  border: 2px solid #ffffff;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.25);
  margin-top: -6px;
  cursor: pointer;
  transition: transform 0.15s ease;
}

.tag-scale-slider::-webkit-slider-thumb:hover {
  transform: scale(1.08);
}

.tag-scale-slider::-moz-range-thumb {
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background: #28a745;
  border: 2px solid #ffffff;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.25);
  cursor: pointer;
}

.tag-scale-slider:focus {
  outline: none;
  box-shadow: none;
}

.tag-scale-slider:focus::-webkit-slider-thumb {
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.25);
}

.tag-scale-slider:focus::-moz-range-thumb {
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.25);
}
</style>
